import React, { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from '../../services/axiosInstance';
import { UserContext } from "../../contexts/UserContext";
import SEO from "../SEO/SEO";
import "./Login.css";

const baseUrl = 'https://whiskyandco.com.ar';

const Login = () => {
  const [loginData, setLoginData] = useState({ username: "", password: "" });
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const navigate = useNavigate();
  const { login } = useContext(UserContext);

  const handleChange = (e) => {
    setLoginData({ ...loginData, [e.target.name]: e.target.value });
  };

  const handleLogin = async (e) => {
    e.preventDefault();

    try {
      const response = await axios.post(`${baseUrl}/auth/login`, {
        username: loginData.username,
        email: loginData.username.includes("@") ? loginData.username : null,
        password: loginData.password
      });

      const { user, token } = response.data;

      if (user.rol !== "Admin") {
        setErrorMessage("Acceso disponible solo para administradores.");
        setSuccessMessage("");
        return;
      }

      await login(user, token);

      setSuccessMessage("Sesion iniciada. Redirigiendo al panel...");
      setErrorMessage("");

      setTimeout(() => {
        navigate("/admin");
      }, 800);
    } catch (error) {
      console.error("Error en el inicio de sesion:", error.response?.data || error);
      setErrorMessage(error.response?.data?.error || "Error al iniciar sesion.");
      setSuccessMessage("");
    }
  };

  return (
    <div className="login-page">
      <SEO
        title="Login Admin | Whisky And Co"
        description="Acceso restringido al panel de administracion."
        canonicalPath="/login-admin"
        noindex
      />

      <div
        className="login-panel-visual"
        style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/img/inicio/portada.jpg)` }}
      >
        <div className="login-visual-inner">
          <img src="/img/marca/logo.png" alt="Whisky & Co" className="login-visual-logo" />
          <span className="login-visual-label">Acceso restringido</span>
          <p className="login-visual-tagline">El sabor de lo extraordinario, gestionado con precisión.</p>
        </div>
      </div>

      <div className="login-panel-form">
        <div className="login-form-inner">
          <span className="login-eyebrow">Panel de administración</span>
          <h1 className="login-heading">Bienvenido</h1>
          <p className="login-subheading">Ingresa tus credenciales para continuar</p>

          {successMessage && (
            <p className="login-feedback login-feedback--success">{successMessage}</p>
          )}
          {errorMessage && (
            <p className="login-feedback login-feedback--error">{errorMessage}</p>
          )}

          <form onSubmit={handleLogin}>
            <div className="login-field">
              <input
                id="username"
                type="text"
                name="username"
                value={loginData.username}
                onChange={handleChange}
                placeholder=" "
                autoComplete="username"
              />
              <label htmlFor="username">Usuario</label>
            </div>

            <div className="login-field">
              <input
                id="password"
                type="password"
                name="password"
                value={loginData.password}
                onChange={handleChange}
                placeholder=" "
                autoComplete="current-password"
              />
              <label htmlFor="password">Contraseña</label>
            </div>

            <button type="submit" className="login-btn">
              Ingresar al panel
            </button>
          </form>

          <div className="login-divider">
            <span className="login-divider-line" />
            <span className="login-divider-text">Whisky &amp; Co · Córdoba</span>
            <span className="login-divider-line" />
          </div>
        </div>
      </div>

    </div>
  );
};

export default Login;
